import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PeriodSelectBox from '../../../global/PeriodSelectBox';
import ManufacturerTransactionsOverview from './ManufacturerTransactionsOverview';
import ManufacturerTransactionsStatistics from './ManufacturerTransactionsStatistics';
import ManufacturerTransactionsProgress from './ManufacturerTransactionsProgress';

const tabs = [
    { key: 'overview', label: 'ManufacturerTransactions.tabs.overview' },
    { key: 'statistics', label: 'ManufacturerTransactions.tabs.statistics' },
    { key: 'progress', label: 'ManufacturerTransactions.tabs.progress' },
];

const ManufacturerTransactions = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('overview');
    const [period, setPeriod] = useState('last_7_days');

    return (
        <Wrapper>
            <Header>
                <div>
                    <Title>{t('ManufacturerTransactions.title')}</Title>
                    <Subtitle>{t('ManufacturerTransactions.subtitle')}</Subtitle>
                </div>
                <PeriodSelectBox value={period} onChange={(event) => setPeriod(event.target.value)} />
            </Header>
            <Tabs>
                {tabs.map((tab) => (
                    <TabButton key={tab.key} $active={activeTab === tab.key} onClick={() => setActiveTab(tab.key)}>
                        {t(tab.label)}
                    </TabButton>
                ))}
            </Tabs>
            <Content>
                {activeTab === 'overview' && <ManufacturerTransactionsOverview period={period} />}
                {activeTab === 'statistics' && <ManufacturerTransactionsStatistics period={period} />}
                {activeTab === 'progress' && <ManufacturerTransactionsProgress period={period} />}
            </Content>
        </Wrapper>
    );
};

export default ManufacturerTransactions;

const Wrapper = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
`;

const Title = styled.h1`
    margin: 0;
    color: rgba(130, 22, 146, 1);
`;

const Subtitle = styled.p`
    margin: 0.25rem 0 0 0;
    color: ${({ theme }) => theme.colors.textSecondary || '#666'};
`;

const Tabs = styled.div`
    display: flex;
    margin-top: 1.5rem;
    border-bottom: 1px solid rgba(130, 22, 146, 0.2);
`;

const TabButton = styled.button`
    background: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 0.08)' : 'transparent')};
    border: none;
    border-bottom: ${({ $active }) => ($active ? '3px solid rgba(130, 22, 146, 1)' : '3px solid transparent')};
    color: ${({ $active }) => ($active ? 'rgba(130, 22, 146, 1)' : '#444')};
    padding: 0.75rem 1.125rem;
    font-weight: 600;
    cursor: pointer;
`;

const Content = styled.div`
    margin-top: 1.5rem;
`;
